import Immutable from 'seamless-immutable'
import {OPEN_ACCOUNT} from 'actions'

const reducer = (state = Immutable({}), {type, response}) => {
  if (type === OPEN_ACCOUNT) {
    return response ? Immutable.merge(state, response) : state
  }
  return state
}

export default reducer
